import { Component, Input, ContentChild, AfterViewInit, ChangeDetectorRef, ViewChild, OnInit } from '@angular/core';

import { FlowComponent } from '../../../flow/components/flow/flow.component';
import { LunaInputDirective } from './luna-input.directive';
import { FormControlLabelComponent } from './form-control-label/form-control-label.component';

@Component({
    selector: 'form-control',
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.scss'],
    standalone: false
})
export class FormControlComponent implements OnInit, AfterViewInit {

    @Input() question: any;
    @Input() flow: FlowComponent;
    @ContentChild(LunaInputDirective) control: LunaInputDirective;
    @ViewChild(FormControlLabelComponent, { static: true }) label: FormControlLabelComponent;

    constructor() {
    }

    ngOnInit() {
        if (this.question && this.question.contextTarget && this.control) {
            let name: string = this.question.contextTarget;
            if (name) {
                if (name.startsWith('$.')) name = name.substring(2, name.length);
                this.control.setName(name);
            }
        }
    }

    ngAfterViewInit() {
        if (!this.control)
            throw 'No input control attached to form control.';
    }
}
